var _path, _path2, _path3, _g, _path4, _g2, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_807_34930)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 77.8892H9.33388C4.22 77.8892 0.0742188 73.7461 0.0742188 68.6361V9.25308C0.0742188 4.14284 4.22 0 9.33388 0H52.2044C57.3183 0 61.4633 4.14284 61.4633 9.25308V31.4588C61.5187 32.0456 61.3243 32.6275 60.9276 33.0629C60.5309 33.4981 59.9691 33.7463 59.3804 33.7463C58.791 33.7463 58.2291 33.4981 57.8324 33.0629C57.4357 32.6275 57.2413 32.0456 57.2968 31.4588V9.25308C57.2968 7.91949 56.7652 6.64132 55.8202 5.7001C54.8751 4.75888 53.5938 4.23255 52.2599 4.23803H9.33388C7.99305 4.22301 6.7028 4.74467 5.74913 5.68671C4.79606 6.62854 4.25981 7.913 4.25981 9.25308V68.6915C4.25981 70.0316 4.79606 71.316 5.74913 72.2579C6.7028 73.1999 7.99305 73.7216 9.33388 73.7066H37.3334C38.4894 73.7066 39.4266 74.6429 39.4266 75.7983C39.4266 76.9526 38.4894 77.8892 37.3334 77.8892Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3148 22.3548H13.1291C12.5426 22.4094 11.9603 22.2151 11.5238 21.8187C11.0883 21.4231 10.8398 20.8608 10.8398 20.2726C10.8398 19.6835 11.0883 19.1221 11.5238 18.7257C11.9603 18.3301 12.5426 18.135 13.1291 18.1904H48.3148C49.3891 18.2919 50.2103 19.1935 50.2103 20.2726C50.2103 21.351 49.3891 22.2533 48.3148 22.3548Z",
    fill: "#818181"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_807_34930",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78 0H0V77.9446H78V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_807_34930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5367 38.6022H13.1842C12.029 38.6022 11.0918 37.6657 11.0918 36.5113C11.0918 35.3562 12.029 34.4204 13.1842 34.4204H32.5367C33.6919 34.4204 34.6289 35.3562 34.6289 36.5113C34.6289 37.6657 33.6919 38.6022 32.5367 38.6022Z",
    fill: "#818181"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_807_34930",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 0H0V77.9446H78V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_807_34930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5917 77.9444C74.9769 77.9444 74.3858 77.7057 73.9438 77.2784L65.9069 69.2471C64.9959 68.3322 65.0008 66.8533 65.9156 65.944C66.8313 65.0338 68.3111 65.0385 69.2211 65.9527L77.2399 74.0212C77.9055 74.688 78.1048 75.6895 77.7444 76.56C77.3835 77.4306 76.5344 77.9984 75.5917 77.9998V77.9444Z",
    fill: "#818181"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8699 68.5997C47.8777 68.5997 42.4758 64.9927 40.1827 59.4609C37.8897 53.9289 39.1576 47.561 43.3948 43.327C47.6317 39.093 54.0032 37.8266 59.5391 40.1183C65.0751 42.4097 68.6846 47.8076 68.6846 53.7955C68.6846 61.9712 62.052 68.5997 53.8699 68.5997ZM53.8699 42.9513C49.494 42.9432 45.545 45.5718 43.8652 49.6099C42.1855 53.6473 43.1059 58.2984 46.1981 61.3931C49.2892 64.4877 53.942 65.4162 57.9856 63.7448C62.0298 62.0727 64.6664 58.1312 64.6664 53.7584C64.6563 47.8013 59.8312 42.9718 53.8699 42.9513Z",
    fill: "#818181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_807_34930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/emptyTable.c3b43e1e0caee32fbf5995dbbdaf0c5d.svg";
export { ForwardRef as ReactComponent };